import { Link, useRouterState } from "@tanstack/react-router";

import { SITE_URL } from "@/lib/site";

export type Crumb = { label: string; to?: string };

/**
 * Kruimelpad voor subpagina's, inclusief BreadcrumbList structured data.
 * Het pad volgt altijd de echte URL van de pagina.
 */
export function PageBreadcrumb({ items, current }: { items?: Crumb[] | undefined; current: string }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const trail: Crumb[] = [{ label: "Home", to: "/" }, ...(items ?? [])];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      ...trail.map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.label,
        item: `${SITE_URL}${c.to === "/" ? "" : (c.to ?? "")}`,
      })),
      {
        "@type": "ListItem",
        position: trail.length + 1,
        name: current,
        item: `${SITE_URL}${pathname}`,
      },
    ],
  };

  return (
    <nav aria-label="Kruimelpad" className="text-xs text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-1.5">
        {trail.map((c) => (
          <li key={c.label} className="flex items-center gap-1.5">
            {c.to ? (
              <Link to={c.to} className="hover:text-foreground hover:underline">
                {c.label}
              </Link>
            ) : (
              <span>{c.label}</span>
            )}
            <span aria-hidden>›</span>
          </li>
        ))}
        <li aria-current="page" className="font-medium text-foreground">
          {current}
        </li>
      </ol>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </nav>
  );
}
